<ng-container *ngIf="totalPages > 1">
	<ngb-pagination
		[boundaryLinks]="true"
		[page]="currentPage"
		(pageChange)="doPageTo($event)"
		[pageSize]="pageLength"
		[collectionSize]="totalPages * pageLength"
		[maxSize]="5"
		[rotate]="true"
		class="d-flex justify-content-center"
	>
		<ng-template ngbPaginationFirst><span class="" ngbTooltip="First">««</span></ng-template>
		<ng-template ngbPaginationPrevious
			><span class="d-inline-block" ngbTooltip="Previous">«</span></ng-template
		>
		<!-- <ng-template ngbPaginationEllipsis>
            <div ngbDropdown class="d-inline-block">
                <button class="btn btn-outline-primary" id="paginationDropdown" ngbDropdownToggle>...</button>
                <div ngbDropdownMenu aria-labelledby="paginationDropdown">
                  <button *ngFor="let page of pages; let i = index" ngbDropdownItem>{{i+1}}</button>
                </div>
              </div>
        </ng-template> -->
		<ng-template ngbPaginationNext
			><span class="d-inline-block" ngbTooltip="Next">»</span></ng-template
		>
		<ng-template ngbPaginationLast
			><span class="d-inline-block" ngbTooltip="Last">»»</span></ng-template
		>
	</ngb-pagination>
</ng-container>
